import httpHandler from '@/scripts/helpers/http-status-code-handler'

export default {
  namespaced: true,
  actions: {
    async apiLogin({ commit }, request) {
      return httpHandler.do(
        commit,
        'post',
        `${process.env.VUE_APP_API_ENDPOINT}/Auth/Login`,
        request,
      )
    },
  },
}
